import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { number } from 'yup';
import ReactSelect from 'components/interaction/ReactSelect/index.jsx';
import { LOCATION_TYPE_CHOOSE, OPTIONS } from './constants.js';
import messages from './messages.js';

function SelectLocationType(props) {
  const { value, withChoose = true, ...rest } = props;
  const intl = useIntl();
  const placeholder = intl.formatMessage(messages.select);
  const options = OPTIONS
    .filter((o) => withChoose || o.value !== LOCATION_TYPE_CHOOSE)
    .map((o) => ({ value: o.value, label: intl.formatMessage(o.label) }));
  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: withChoose ? '16em' : '12em',
    }),
  };
  return (
    <ReactSelect options={options} {...rest} styles={customStyles} placeholder={placeholder} value={value === null ? undefined : value} />
  );
}

SelectLocationType.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  withChoose: PropTypes.bool,
};

SelectLocationType.getSchema = () => number();

export default SelectLocationType;
